export default class Module {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      shortcut: null,
      translations: {
        de: {
          name: null
        },
        en: {
          name: null
        }
      }
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      shortcut: this.shortcut,
      translations: this.translations
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/module/model.js